export default "__VITE_ASSET__DFM5r0E5__"